/* globals cpac, $, showResources, $j, showAjaxStarted, Ajax, showResponse, reportAjaxError, nameFieldOnFocus, my_isset, formSelectToggle, closeModalForm, formSelect, parceCourtGreed, showResponseInModal, Class, Windows, $F, showModalForm, modalWin, cpacDate, leFixedScroll */

if (typeof cpac !== 'undefined') {
  var resourcesPropertiesForm;
  var ajaxDiv;
  var IS_ALLOWED_TO_CHANGE_DEFAULT_RATE;

  cpac.tennis = {
    updating: false,
    baseUrl : '/',
    defaultController: '',
    allPriceTypes: {'per_hour': 'Per Court/Hour', 'full': 'Per Court'},
    defaultPriceType: 'Per Court/Hour',
    defaultPrice: '-default-',
    defaultPriceValue: '-1',
    unknowkUserIterator: -1,
    callback: {add_player: false, remove_player: false},
    reserveForMember: false,
    placeholderForOther: '',
    placeholderForPrimary: '',
    playerOptions: {},
    
    toggleReserveButtons: function(id) {
         if( id != 'reserve-court-button' && $('reserve-court-button'))
             $('reserve-court-button').removeClassName('active');
  
         if( id != 'private-lesson-button' && $('private-lesson-button'))
             $('private-lesson-button').removeClassName('active');
  
         if( id != 'reserve-permanent-button' && $('reserve-permanent-button'))
             $('reserve-permanent-button').removeClassName('active');
  
         if( id != 'view-activities-button' && $('view-activities-button'))
             $('view-activities-button').removeClassName('active');
  
         if( id != 'edit-button' && $('edit-button'))
             $('edit-button').removeClassName('active');
  
         if( id != 'reserve-block-button' && $('reserve-block-button'))
             $('reserve-block-button').removeClassName('active');
  
         if( id != 'reserve-permanent-quick-event-button' && $('reserve-permanent-quick-event-button'))
             $('reserve-permanent-quick-event-button').removeClassName('active');
  
         if( id != 'rain-court-button' && $('rain-court-button'))
             $('rain-court-button').removeClassName('active');
  
         if( id != 'pro-scheduling-button' && $('pro-scheduling-button'))
             $('pro-scheduling-button').removeClassName('active');
  
         if( id != 'reserve-permanent-member-button' && $('reserve-permanent-member-button'))
             $('reserve-permanent-member-button').removeClassName('active');
  
         if( id != 'reserve-permanent-staff-button' && $('reserve-permanent-staff-button'))
             $('reserve-permanent-staff-button').removeClassName('active');
     },
  
    reserveCourt: function(sender, dontLoadCourts) {try {
         if( this.updating ) {
             return;
         }
  
         this.toggleReserveButtons(sender.id);
         $(sender).toggleClassName('active');
         var href;
  
         if( $(sender).hasClassName('active') )
         {
             href = sender.href;
             href += href.indexOf('?') > -1 ? '&date=' : '?&date=';
             href += $('date').value;
             href += '&locations=' + ( $('locations') ? $('locations').value : 0 );
  
             this.updating = true;
  
             showResources( null, href, 'court-properties-container', function(r){
                 cpac.tennis.updating = false;
                 if ($('edit-button')) {
                     $('edit-button').hide();
                 }
  
                 if( r.getHeader('X-Dont-Load-Courts') || sender.id == 'reserve-permanent-button' || sender.id == 'reserve-block-button' || sender.id == 'rain-court-button' || sender.id == 'reserve-permanent-quick-event-button' || dontLoadCourts || sender.id == 'resource-waitlist') {
                     $('courtsInfo').update('');
                     $('courtsInfo').setStyle({minHeight: '150px'});
                     return;
                 }
  
                 showResources($('courtScheduleProperties'), cpac.tennis.baseUrl+'resource/court-schedule', 'courtsInfo' );
             });
         } else {
             href = cpac.tennis.baseUrl + cpac.tennis.defaultController + '/index';
             href += '?date=' + $('date').value;
             href += '&locations=' + ( $('locations') ? $('locations').value : 0 );
  
             showResources( null, href, 'court-properties-container', function(){
                 if ($('courtsInfo')) {
                     var courtsInfoUrl = cpac.tennis.baseUrl + 'resource/court-schedule';
                     if (sender.href.indexOf('groupex') > -1) {
                         courtsInfoUrl += '?groupex=1';
                     }
                     showResources($('courtScheduleProperties'), courtsInfoUrl, 'courtsInfo', function () {
                         cpac.tennis.updating = false;
                         if ($('edit-button')) {
                             $('edit-button').show();
                         }
                     });
                 }
             });
         }
         
         // set focus
         if (sender.id == 'reserve-permanent-member-button') {
             setTimeout(function(){$j('#rcUserName').focus()}, 500);
         }
         else if (sender.id == 'reserve-permanent-staff-button') {
             setTimeout(function(){$j('#tennis_pro').focus()}, 500);
         }
         else if (sender.id == 'reserve-block-button') {
             setTimeout(function(){$j('#e_name').focus()}, 500);
         }
     }
     catch(e) {cpac.error(e)}}
  
     ,reserveCourtEdit: function(url, buttonId, onComplete)
     {
         if( ! onComplete )
             onComplete = function(){};
  
         if( ! buttonId )
             buttonId = 'reserve-court-button';
  
         this.toggleReserveButtons(buttonId);
  
         if( ! $( buttonId ).hasClassName('active') )
         {
             this.updating = true;
  
             resourcesPropertiesForm = null;
  
             url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
             showAjaxStarted();
  
             ajaxDiv = $('court-properties-container');
             new Ajax.Request( url, {
                 method: 'GET',
                 onComplete: function(request) {
                     showResponse(request, ajaxDiv);
                     showResources($('courtScheduleProperties'), cpac.tennis.baseUrl+'resource/court-schedule', 'courtsInfo', function(){
                         cpac.tennis.updating = false;
                         if ($('edit-button')) {
                             $('edit-button').hide();
                         }
                         $( buttonId ).toggleClassName('active');
                         onComplete();
                     });
                 },
                 onFailure: reportAjaxError
             });
         }
     }
  
     ,privateLessonEdit: function(url, buttonId) {
         if( !buttonId ) {
             buttonId = 'private-lesson-button';
         }
         this.reserveCourtEdit(url, buttonId);
     }
  
     ,reserveBlockTime: function(url) {try {
         var buttonId = 'reserve-block-button';
         this.reservePermanentEdit(url, buttonId);
     }
     catch(e){cpac.error(e)}}
  
     ,reserveRainCourt: function(url) {try {
         var buttonId = 'rain-court-button';
         this.reservePermanentEdit(url, buttonId);
     }
     catch(e){cpac.error(e)}}
  
   ,reserveQuickEvent: function(url) {try {
         var buttonId = 'reserve-permanent-quick-event-button';
         this.reservePermanentEdit(url, buttonId);
     }
     catch(e){cpac.error(e)}}
  
     ,reservePermanentEdit: function(url, buttonId) {try {
  
         if( ! buttonId ) {
             buttonId = 'reserve-permanent-button';
         }
  
         this.toggleReserveButtons(buttonId);
  
         if( ! $( buttonId ).hasClassName('active') )
         {
             this.updating = true;
  
             resourcesPropertiesForm = null;
  
             url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
             showAjaxStarted();
  
             ajaxDiv = $('court-properties-container');
             new Ajax.Request( url, {
                 method: 'GET',
                 onComplete: function(request) {
                     showResponse(request, ajaxDiv);
  
                     cpac.tennis.updating = false;
                     if ($('edit-button')) {
                         $('edit-button').hide();
                     }
                     $( buttonId ).toggleClassName('active');
                     $('courtsInfo').update('');
                     $('courtsInfo').setStyle({minHeight: '150px'});
                 },
                 onFailure: reportAjaxError
             });
         }
     }
     catch(e){cpac.error(e)}}
  
   ,anotherPlayer: function()
   {
     if( ! $('rcUserSearchBox').visible() ){
       $('rcUserSearchBox').show();
     } else {
       $('rcUserSearchBox').hide();
     }
    },
    nameFieldOnFocus: function (nameFieldId, valueFieldId, isGuestFieldId, group, createGuest, sex, statuses, noguest, cb, showunknown, componentRestriction ) {
         var callbackFunc = function (obj) {
             $(valueFieldId).value = obj.id;
             if ($(valueFieldId).onchange) $(valueFieldId).onchange();
             if ($(isGuestFieldId)) {
                 var isGuest = obj.extra.indexOf('is guest') >=0;
                 $(isGuestFieldId).value = isGuest ? '1' : '0';
             }
             if( cb ) {
                 cb(obj);
             }
         }
         return nameFieldOnFocus(nameFieldId, valueFieldId, group, createGuest, sex, statuses, noguest, callbackFunc, showunknown, null, componentRestriction );
     }
         ,addPlayer: function( id, name, price, priceType, replace, isGuest, cantChangePlayers ){try {
         if (!id) {
             id = new String($('rcUserId').value);
         }
         if (id == cpac.unknownProfileId) {
             this.unknowkUserIterator++
         }
  
         var newDivId = 'rcPlayer' + id;
  
         // check if such player already exists
         if ((id > 0 && $(newDivId) == null) || (id == (cpac.unknownProfileId))) //+'_'+this.unknowkUserIterator)))
         {
             if (!price) {
                 price = $('rcUserPrice').value;
             }
  
             if (price == '-default-') {
                 //
             } else
                 if (!isNaN(price)) {
                     //
                 } else {
                     return false;
                 }
  
             if ($('rcHiddenPlayerList').value == '') {
                 $('rcHiddenPlayerList').value = id;
                 if ($('rcNone')) {
                     $('rcAddedPlayers').removeChild($('rcNone'));
                 }
             } else {
                 $('rcHiddenPlayerList').value += ',' + id;
             }
  
             if (!priceType) {
                 priceType = $('price_type').value;
             }
             var priceTypeValue = priceType;
             priceType = typeof (this.allPriceTypes[priceType]) != 'undefined' ? this.allPriceTypes[priceType] : this.defaultPriceType;
  
             if (!name) {
                 name = $('rcUserName').value;
             }
  
             if (cantChangePlayers === undefined && $j('#cantChangePlayers').length == 1) {
                 cantChangePlayers = !!parseInt($j('#cantChangePlayers').val());
             }
  
             var playerString = document.createElement("div");
             playerString.className = 'player-item-box';
             playerString.id = newDivId;
             var echo = '';
             echo += '<div class="fb-user-box">';
              if (!cantChangePlayers) {
                 echo += '<a onclick="cpac.tennis.removePlayer(' + id + ', null, this.parentNode.parentNode);" href="javascript:void(0)" class="fb-user-box-close"></a>';
              }
             echo += '<a href="/user/edit/?id=' + id + '" class="fb-user-box-title">' + name + '</a>';
             echo += '</div>';
  
             // user package 
             var upackage = $j('#upackage_' + id);
             if (upackage.length && $j('#upackage_' + id).data('isLoaded') != true) {
                 cantChangePlayers = true;
                 $j('#upackage_' + id).data('isLoaded', true);
                 echo += '<div class="package_label">Package</div>';
             }
  
             var inputPostfix = id == cpac.unknownProfileId ? id + '[' + this.unknowkUserIterator + ']' : id;
             if (cantChangePlayers || window.cpacTennisPlayerHidePrice) {
                 echo += price == '-default-' ? '<span> </span>' : ' <span>($' + price + ' ' + priceType + ')</span> ';
                 echo += '<input type="hidden" id="price_' + id + '" name="price_' + inputPostfix + '" value="' + price + '" />';
                 echo += '<input type="hidden" id="price_type_' + id + '" name="price_type_' + inputPostfix + '" value="' + priceTypeValue + '" />';
             } else {
                 if( typeof this.allPriceTypes != 'object' ) {
                     this.allPriceTypes = JSON.parse(this.allPriceTypes);
                 }
                 echo += '<div class="player-price-type">';
                 echo += cpac.formSelect({
                                             name:'price_type_' + inputPostfix, options:this.allPriceTypes, 'default':priceTypeValue, 'className':'report-select'
                                         });
                 echo += '</div>';
  
                 echo += '<div class="player-price">$&nbsp;';
                 echo += '<input class="field thin-border" type="text" id="price_' + id + '" name="price_' + inputPostfix + '" value="' + price + '" onclick="' + "if(this.value=='-default-')this.value=''" + '" onchange="' + "if(this.value=='')this.value='-default-'" + '" onblur="' + "if(this.value=='')this.value='-default-'" + '" class="price"/>';
                 echo += '</div>';
             }
             
             playerString.innerHTML = echo;

             if (!replace) {
                 $('rcAddedPlayers').appendChild(playerString);
                 $('rcUserName').value = '';
                 $('rcUserId').value = '';
                 $('rcUserPrice').value = '-default-';
                 if ($('rcUserSearchBox')) {
                     $('rcUserSearchBox').hide();
                 }
             } else {
                 replace.insert({after:playerString});
             }
  
             if (!my_isset(isGuest)) {
                 isGuest = $('rcUserIsGuest') ? $('rcUserIsGuest').value : 0;
             }
             if (isGuest == '1') {
                 $j('#' + newDivId).addClass('player-item-box-guest');
             }
  
             this.refreshGuestBills();
  
             return true;
         } else
             if (!id || id == '0' || id == '') {
                 alert('Please enter valid player name');
             } else {
                 return false;
             }
         } catch(e) {cpac.error(e)}
     },
  
     /**
      * 
      * @param {type} id
      * @param {type} name
      * @param {type} price
      * @param {type} priceType
      * @param {type} replace
      * @param {type} isGuest
      * @param {type} cantChangePlayers
      * @param {string} target _target
      * @param {boolean} splitter dropable  area after player
      * @returns {Boolean}
      */
     addPlayerRC: function( id, name, price, priceType, replace, isGuest, cantChangePlayers, target, splitter) {
         try {
            if (!id) {
                id = new String($('rcUserId').value);
            }
            if (id == cpac.unknownProfileId) {
                this.unknowkUserIterator++
            }
  
            var newDivId = 'rcPlayer' + id;
  
             // check if such player already exists
             if ((id > 0 && $(newDivId) == null) || (id == (cpac.unknownProfileId))) {
                 // price
                 if( ! price ) {
                     price = $('rcUserPrice').value;
                 }
                 if( (isNaN( price )) || (parseFloat(price) == parseFloat(this.defaultPriceValue)) ) {
                     price = '';
                 }
                 // price type: % or $
                 if( ! priceType ) {
                     priceType = $('rcUserPriceType').value;
                 }
                 if( ! priceType ) {
                     priceType = '$';
                 }
  
                 if ($('rcHiddenPlayerList').value == '') {
                     $('rcHiddenPlayerList').value = id;
                     if ($('rcNone')) {
                         $('rcAddedPlayers').removeChild($('rcNone'));
                     }
                 } else {
                     $('rcHiddenPlayerList').value += ',' + id;
                 }
  
                 if( ! name ) {
                     name = $('rcUserName').value;
                 }
  
                 if( cantChangePlayers === undefined && $j('#cantChangePlayers').length == 1 ) {
                     cantChangePlayers = !!parseInt($j('#cantChangePlayers').val());
                 }
  
                 var playerString = document.createElement("div");
                 playerString.className = 'player-item-box';
                 playerString.id = newDivId;
                 playerString.setAttribute('data-id', ''+id);
                 var echo = '';
                 echo += '<div class="fb-user-box">';
                 var splitterRemove = '';
                 if (typeof splitter !== "undefined") {
                     splitterRemove = ', true';
                 }
                  if( !cantChangePlayers ) {
                     echo += '<a onclick="cpac.tennis.removePlayer('+id+', null, this.parentNode.parentNode'+splitterRemove+');" href="javascript:void(0)" class="fb-user-box-close"></a>';
                  }
                 if (target === undefined) {
                     target = '';
                 } else {
                     target = ' target ="' + target + '" ';
                 }
                 echo += '<a href="/user/edit/?id='+id+'"' + target + 'class="fb-user-box-title">'+name+'</a>';
                 echo += '</div>';
  
                // user package 
                var upackage = $j('#upackage_' + id);
                if (upackage.length && $j('#upackage_' + id).data('isLoaded') != true) {
                    cantChangePlayers = true;
                    $j('#upackage_' + id).data('isLoaded', true);
                    echo += '<div class="package_label">Package</div>';
                }
                
                var inputPostfix = id == cpac.unknownProfileId ? id + '[' + this.unknowkUserIterator + ']' : id;
                if( cantChangePlayers || window.cpacTennisPlayerHidePrice ) {
                    echo += '<div style="height: 21px; line-height: 23px; font-size: 12px;">';
                    if (!(price == 0 && priceType == '%') && !isNaN(parseFloat(price))) {    // default
                        echo += priceType == '$' ? '$'+price : price+''+priceType;                   
                    }
                    echo += '</div>';
                    echo += '<input type="hidden" id="p_type_'+id+'" name="p_type_'+id+'" value="'+priceType+'" />';
                    echo += '<input type="hidden" id="percent_'+id+'" name="percent_'+id+'" value="'+price+'" />';
                } else {
                    var season_price = $('season_price').value;
                    var display = '';
                    if ((season_price == '-default-') || (season_price == '')) {
                        display = 'display: none;';
                        priceType = '$';
                    }
                    // select $ or %
                    var selected1 = priceType == '$' ? '' : ' selected';
                    var selected2 = priceType == '$' ? ' selected' : '';
                    echo +=
                    '<div class="rcUserPriceType" style="float: left;">' +
                    '<div class="cs-select left-oriented" style="width: 46px; float: left;">' +
                    '<select style="'+ display +' width: 67px; margin: 0px; background-position: 30px 50%;" class="perm_fee_type" id="p_type_' + id + '" name="p_type_' + id + '" onchange="$j(\'.perm_fee_type\').val($j(this).val()); $j(\'#rcUserPriceType\').val($j(this).val());">' +
                    '<option label="" value="%" ' + selected1 + '>%</option>' +
                    '<option label="" value="$" ' + selected2 + '>$</option>' +
                    '</select>' + ' <span class="dollar_price_span" >' + priceType + '</span> ' +
                    '</div>';
                    '</div>';
  
  
                    echo += '<div class="player-percent" style="float: left;">';
                    var disableChangeDefaultPrice = (
                            (typeof(IS_ALLOWED_TO_CHANGE_DEFAULT_RATE) === "undefined")
                            || (IS_ALLOWED_TO_CHANGE_DEFAULT_RATE === 1)
                        )
                        ? ''
                        : ' disabled';
                    echo += '<input class="field thin-border" type="text" id="percent_'+id+'" name="percent_'+id+'" value="'+(price != '' ? price : '-default-')+'" onclick="if(this.value==\'-default-\')this.value=\'\'"  onblur="if(this.value==\'\')this.value=\'-default-\'" style="width: 48px;"' + disableChangeDefaultPrice + '/>';
                    echo += '</div>';
                }
  
                 playerString.innerHTML = echo;
  
                 if( ! replace ) {
                     $('rcAddedPlayers').appendChild(playerString);
                     $('rcUserName').value = '';
                     $('rcUserId').value = '';
                     $('rcUserPrice').value = '-default-';
                     if( $('rcUserSearchBox')) {
                         $('rcUserSearchBox').hide();
                     }
                 } else {
                     replace.insert({after: playerString});
                 }
                  if (typeof splitter !== "undefined" 
                      && splitter !== false 
                      && typeof $j !== "undefined"
                     ) {
                     var playerId = '' + id,
                         playerCount = $j('div[id^="rcPlayer"]:not([id^="rcPlayerComplimentaryReason"])').length;
                         
                     if ((playerCount != 1) && (playerCount % 4 == 1)) {
                         var prevPlayer = $j('div[id^="rcPlayer"]:not([id^="rcPlayerComplimentaryReason"])').eq(playerCount-1),
                             prevPlayerId = prevPlayer.data('id'),
                             splitterPosition = playerCount - 1;
                         $j('<div class="splitter-area" data-player="' + prevPlayerId + '" data-splitter="'+ splitterPosition +'"><div class="splitter-wrapper"><hr class="player-splitter-line"><i class="fa fa-chevron-circle-left"></i></div></div>').insertBefore(prevPlayer);
                     }
                     
                  }
  
                if (!my_isset(isGuest)) {
                    isGuest = $('rcUserIsGuest') ? $('rcUserIsGuest').value : 0;
                }
  
                var guestId = 0;
                if (isGuest == '1') {
                    $j('#'+ newDivId).addClass('player-item-box-guest');
                    guestId = id;
                }
  
                this.refreshGuestBills(guestId);
  
                 if (this.callback.add_player) {
                    this.callback.add_player(id, name);
                 }
  
                 return true;
             } else
                 if (!id || id == '0' || id == '') {
                     alert('Please enter valid player name');
                 } else {
                     return false;
                 }
         } catch(e) {cpac.error(e)}}
    
     ,addPlayerGhost: function( name ){try {
            var id = Math.floor((Math.random() * 1000000000) + 1); ;
            var newDivId = 'rcPlayer' + id;
            var userBoxId = 'userBox' + id;
            
                var playerString = document.createElement("div");
                playerString.className = 'player-item-box';
                playerString.id = newDivId;
                var echo = '';
                echo += '<div class="fb-user-box" id="' + userBoxId + '">';
                echo += '<a onclick="cpac.tennis.removePlayerGhost(\'' + userBoxId + '\'); cpac.tennis.removePlayer('+id+', null, this.parentNode.parentNode);" href="javascript:void(0)" class="fb-user-box-close"></a>';
  
                
                echo += '<span class="fb-user-box-title">' + name + ' (guest)</span>';
                echo += '</div>';
                
                playerString.innerHTML = echo;
                $('rcAddedPlayers').appendChild(playerString);
                $j('#' + userBoxId).attr('pname', name);
                return true;
  
        } catch(e) {cpac.error(e)}}
        
     ,removePlayerGhost: function(id) {
             var name = $j('#' + id).attr('pname');
             var obj = $j.parseJSON( $j('#rcHiddenPlayerGhostList').val() );
             delete obj[name];
             var json_string = Object.toJSON(obj);
             $j('#rcHiddenPlayerGhostList').val(json_string);
         }
  
     ,refreshGuestBills : function(playerGuestId) {
         var countGuests = $j('#rcAddedPlayers > .player-item-box-guest').size();
         var countMembers = $j('#rcAddedPlayers > .player-item-box').size() - countGuests;
  
         if (cpac.tennis.reserveForMember) {
             if (playerGuestId) {
                 var newGuestBills = $j('#guest_bills').clone(true, true);
  
                 newGuestBills.find('#guest_bill_guest_fee').attr('id', 'guest_bill_guest_fee_' + playerGuestId).attr('name', 'guest_bill_guest_fee[' + playerGuestId + ']');
  
                 newGuestBills.find('#guest_bill_to_members-select-caption').attr('id', 'guest_bill_to_members_' + playerGuestId + '-select-caption');
                 newGuestBills.find('#hidden_filter_guest_bill_to_members').attr('id', 'hidden_filter_guest_bill_to_members_' + playerGuestId);
                 newGuestBills.find('#guest_bill_to_members').attr('id', 'guest_bill_to_members_' + playerGuestId).attr('name', 'guest_bill_to_members[' + playerGuestId + ']');
  
                 newGuestBills.find('#guest_fee_to_members-select-caption').attr('id', 'guest_fee_to_members_' + playerGuestId + '-select-caption');
                 newGuestBills.find('#hidden_filter_guest_fee_to_members').attr('id', 'hidden_filter_guest_fee_to_members_' + playerGuestId);
                 newGuestBills.find('#guest_fee_to_members').attr('id', 'guest_fee_to_members_' + playerGuestId).attr('name', 'guest_fee_to_members[' + playerGuestId + ']');
  
                 newGuestBills.find('#guest_bill_to_members_' + playerGuestId + '-select-caption').attr('onclick', '').click(
                     function() {
                         formSelectToggle('guest_bill_to_members_' + playerGuestId, 300);
                     }
                 );
  
                 newGuestBills.find('#hidden_filter_guest_bill_to_members_' + playerGuestId + ' a').each(
                     function() {
                         $j(this).attr('onclick', '').click(function(){
                             var optionValue = parseFloat($j(this).attr('id').split("_").last());
  
                             formSelect.selectOption($j(this)[0], $j(this)[0].parentNode.parentNode, 'guest_bill_to_members_' + playerGuestId, optionValue, 1);
                         })
                     }
                 );
  
                 newGuestBills.find('#guest_fee_to_members_' + playerGuestId + '-select-caption').attr('onclick', '').click(
                     function() {
                         formSelectToggle('guest_fee_to_members_' + playerGuestId, 300);
                     }
                 );
  
                 newGuestBills.find('#hidden_filter_guest_fee_to_members_' + playerGuestId + ' a').each(
                     function() {
                         $j(this).attr('onclick', '').click(function(){
                             var optionValue = parseFloat($j(this).attr('id').split("_").last());
  
                             formSelect.selectOption($j(this)[0], $j(this)[0].parentNode.parentNode, 'guest_fee_to_members_' + playerGuestId, optionValue, 1);
                         })
                     }
                 );
  
                 newGuestBills.attr('id', '');
                 newGuestBills.show().appendTo($j('#rcPlayer' + playerGuestId));
  
                 if (cpac.tennis.playerOptions != undefined) {
                     if (cpac.tennis.playerOptions.chargeGuestFee != undefined) {
                         var chargeGuestFeeValue = undefined;
  
                         if (cpac.tennis.playerOptions.chargeGuestFee.players != undefined && cpac.tennis.playerOptions.chargeGuestFee.players[playerGuestId] != undefined) {
                             chargeGuestFeeValue = cpac.tennis.playerOptions.chargeGuestFee.players[playerGuestId];
                         } else if (cpac.tennis.playerOptions.chargeGuestFee['default'] != undefined) {
                             chargeGuestFeeValue = cpac.tennis.playerOptions.chargeGuestFee['default'];
                         }
  
                         var chargeFeeButton = newGuestBills.find('.charge-guest-fee');
  
                         if (chargeGuestFeeValue != 0) {
                             if (chargeFeeButton.hasClass('checkbox-off')) {
                                 chargeFeeButton.click();
                                 newGuestBills.find('.guest-fee-to-smb-container').show();
                             }
                         } else {
                             if (chargeFeeButton.hasClass('checkbox-on')) {
                                 chargeFeeButton.click();
                                 newGuestBills.find('.guest-fee-to-smb-container').hide();
                             }
                         }
                     }
  
                     if (cpac.tennis.playerOptions.billGuestFee != undefined) {
                         var billGuestFeeValue = undefined;
  
                         if (cpac.tennis.playerOptions.billGuestFee.players != undefined && cpac.tennis.playerOptions.billGuestFee.players[playerGuestId] != undefined) {
                             billGuestFeeValue = cpac.tennis.playerOptions.billGuestFee.players[playerGuestId];
                         } else if (cpac.tennis.playerOptions.billGuestFee['default'] != undefined) {
                             billGuestFeeValue = cpac.tennis.playerOptions.billGuestFee['default'];
                         }
  
                         if (billGuestFeeValue != undefined) {
                             newGuestBills.find('#hidden_filter_guest_fee_to_members_' + playerGuestId).find('#guest_fee_to_members_row_' + billGuestFeeValue).click();
                         }
                     }
  
                     if (cpac.tennis.playerOptions.billGuestCharge != undefined) {
                         var billGuestChargeValue = undefined;
  
                         if (cpac.tennis.playerOptions.billGuestCharge.players != undefined && cpac.tennis.playerOptions.billGuestCharge.players[playerGuestId] != undefined) {
                             billGuestChargeValue = cpac.tennis.playerOptions.billGuestCharge.players[playerGuestId];
                         } else if (cpac.tennis.playerOptions.billGuestCharge['default'] != undefined) {
                             billGuestChargeValue = cpac.tennis.playerOptions.billGuestCharge['default'];
                         }
  
                         if (billGuestChargeValue != undefined) {
                             newGuestBills.find('#hidden_filter_guest_bill_to_members_' + playerGuestId).find('#guest_bill_to_members_row_' + billGuestChargeValue).click();
                         }
                     }
                 }
             }
         } else {
             $j('#guest_bills').show();
             $j('#guest_bills').find('.checkbox-off, .checkbox-on').hide();
             $j('#guest_bills').find('#guest_bill_to_members-select-caption, #guest_fee_to_members-select-caption').hide();
  
             if (countGuests >= 1) {
                 $j('#guest_bills').find('.checkbox-off, .checkbox-on').show();
             }
             if (countMembers >= 1) {
                 if (countGuests >= 1) {
                     $j('#guest_bills').find('#guest_bill_to_members-select-caption, #guest_fee_to_members-select-caption').show();
                 }
             }
         }
  
         var primaryReplacement = ' (Primary)';
         if (cpac.tennis.reserveForMember) {
             primaryReplacement = ' (Host)';
         }
  
         $j('#rcAddedPlayers > .player-item-box a.fb-user-box-title').each(function() {
             $j(this).html($j(this).html().replace(primaryReplacement, ''));
         });
         $j('#rcAddedPlayers > .player-item-box a.fb-user-box-title:first').each(function() {
             $j(this).html($j(this).html() + primaryReplacement);
         });
  
         if (!($j('#rcAddedPlayers > .player-item-box').length)) {
             $j('#fakeUserName')
                 .caUserPicker('clearItem')
                 .caUserPicker('option', 'placeholder', cpac.tennis.placeholderForPrimary)
                 .blur();
         }
     }
  
     ,editPlayer: function(id) {try {
         var playerItem = $('rcPlayer'+id);
         if( playerItem ) {
             var playerName      = playerItem.down('.player-name').innerHTML;
             var playerPrice     = playerItem.down('[name="price_'+id+'"]').value;
             var playerPriceType = playerItem.down('[name="price_type_'+id+'"]').value;
  
       var playerString = document.createElement("div");
       playerString.className = 'player-item-edit';
             playerString.id = 'rcEditPlayer'+id;
             var echo = '';
             echo += '<div class="player-name">Player name&nbsp;';
             echo += '<input id="rcUserEditName'+id+'" type="text" class="field" value="'+playerName+'" onFocus="cpac.tennis.nameFieldOnFocus('+"'rcUserEditName"+id+"', 'rcUserEditId"+id+"', 'rcUserEditIsGuest"+id+"', null, 1, null, null, 1);"+'" />';
             echo += '<input id="rcUserEditIsGuest'+id+'" type="hidden" value="0" />';
             echo += '</div>';
             if( window.cpacTennisPlayerHidePrice ) {
                 echo += '<input type="hidden" id="rcUserEditPrice'+id+'" value="'+playerPrice+'" />';
                 echo += '<input type="hidden" id="rcUserEditPriceType'+id+'" value="'+playerPriceType+'" />';
             }else {
                 echo += '<div class="player-price">$&nbsp;';
                 echo += '<input class="field" type="text" id="rcUserEditPrice'+id+'" value="'+playerPrice+'" onclick="'+"if(this.value=='-default-')this.value=''"+'" onchange="'+"if(this.value=='')this.value='-default-'"+'" onblur="'+"if(this.value=='')this.value='-default-'"+'" class="price"/>';
                 echo += '</div>';
                 echo += '<div class="player-price-type">';
                 echo += cpac.formSelect({
                      name: 'rcUserEditPriceType'+id
                     ,options: this.allPriceTypes
                     ,'default': playerPriceType
                 });
                 echo += '</div>';
             }
             echo += '<div class="player-save-changes">';
             echo += '<button class="button nicebutton" type="button" value="Save" onclick="cpac.tennis.saveEditPlayer('+id+');">Save</button>';
             echo += '</div>';
             echo += '<input type="hidden" id="rcUserEditId'+id+'" value="'+id+'">';
  
             playerString.innerHTML = echo;
             playerItem.hide();
             playerItem.insert({after: playerString});
         }
     }
     catch(e){cpac.error(e)}}
  
     ,saveEditPlayer: function(id) {try {
         var newid   = $('rcUserEditId'+id).getValue();
         var name    = $('rcUserEditName'+id).getValue();
         var price   = $('rcUserEditPrice'+id).getValue();
         var type    = $('rcUserEditPriceType'+id).getValue();
         var isGuest = $('rcUserEditIsGuest'+id) ? $('rcUserEditIsGuest'+id).getValue() : '0';
  
         if( newid != id ) {
             if( ! this.addPlayer( newid, name, price, type, $('rcPlayer'+id ), isGuest)) {
                 return;
             }
             this.removePlayer(id, 'rc');
         }else {
             var playerItem = $('rcPlayer'+id);
  
             if( type != 'per_hour' && type != 'full' ) {
                 return;
             }
  
             var priceType = typeof (this.allPriceTypes[type]) != 'undefined' ? this.allPriceTypes[type] : this.defaultPriceType;
             //switch( type ) {
             //    case 'per_hour':priceType = 'per hour';break;
             //    case 'full' :priceType = 'per court/person';break;
             //}
  
             if( price == '-default-' ) {
                 playerItem.down(1).update(' ');
             } else if( ! isNaN( price )) {
                 playerItem.down(1).update(' $'+ price+' '+ priceType+' ');
             } else return;
  
             $('price_'+id).setValue(price);
             $('price_type_'+id).setValue(type);
  
             playerItem.show();
         }
         $('rcEditPlayer'+id).remove();
     }
     catch(e){cpac.error(e);}}
  
   ,removePlayer: function(id, prefix, divId, splitter)
   {
         if( ! prefix ) {
             prefix = 'rc';
         }
  
         if (divId == undefined) {
             divId = prefix + 'Player' + id;
         }
     $(divId).remove();
  
     var oldId = $( prefix + 'HiddenPlayerList').value.split('');
     var newId = '';
     var value = '';
         var removedOne = false;
     for( var i = 0; i < oldId.length; i++ )
     {
       if( oldId[i] == ',' ) {
         if( (value != id || (value == id && id == cpac.unknownProfileId && removedOne == true)) && value != '') {
           if( newId.length > 0 ) {
             newId += ',';
           }
           newId += value;
         } else if (value == id && id == cpac.unknownProfileId) {
                     removedOne = true;
                 }
         value = '';
         continue;
       } else {
         value += (''+oldId[i]);
       }
     }
     if( (value != id || (value == id && id == cpac.unknownProfileId && removedOne == true)) ) {
             if( newId.length > 0 ) {
                 newId += ',';
             }
       newId += value;
     }
         if (typeof splitter !== "undefined" && typeof $j !== "undefined") {
             $j('.splitter-area').each(function(){
                 if ($j(this).data('player') == divId.id.replace('rcPlayer', '')) {
                     $j(this).remove();
                 }
             });
         }
     $( prefix + 'HiddenPlayerList').value = newId;
  
         this.refreshGuestBills();
  
         if (this.callback.remove_player){
             this.callback.remove_player(id);
         }
   }
  
     ,reserveCourtConfirm: function(toggleButton) {
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         url += '&is_confirmed=1&confirmed_ar=1';
         this.reserveCourtSave({
              toggle: toggleButton ? toggleButton : 'reserve-court-button'
             ,url: url
             ,afterSubmit: function(){
                 closeModalForm();
             }
         }, true);
     },
     
     reserveCourtConfirmOverride: function(toggleButton) {
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         url += '&confirmed_ar=1&skipMemberRestrictions=1';//on this step we already confirm restrictions
         this.reserveCourtSave({
              toggle: toggleButton ? toggleButton : 'reserve-court-button'
             ,url: url
             ,afterSubmit: function(){
                 closeModalForm();
             }
         }, true);
     },
     
     reserveUserConfirm: function(toggleButton) {
         closeModalForm();
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         url += '&skipUserAvailability=1';
         $j('#courtScheduleProperties').find('[name="skipUserAvailability"]').val(1);
         this.reserveCourtSave({
              toggle: toggleButton ? toggleButton : 'reserve-court-button'
             ,url: url
         }, true);
     },

      confirmStaffAvailabilityOverriding: function() {
          closeModalForm();
          $j('#courtScheduleProperties').find('[name="skipStaffAvailabilityCheck"]').val(1);
          this.reserveCourtSave(null, true);
      },

      confirmStaffAvailabilityOverridingOnEventDragger: function(url) {
          closeModalForm();
          $j('#courtScheduleProperties').find('[name="skipStaffAvailabilityCheck"]').val(1);
          showResources($('courtScheduleProperties'), url, 'courtsInfo')
      },

      // instructor schedule on activities, see view-pro-schedule.phtml
      confirmStaffAvailabilityOverridingOnStaffSchedule: function() {
          closeModalForm();
          $j('#staffScheduleForm').find('[name="skipStaffAvailabilityCheck"]').val(1);
          $j('td.date.overridable').find('a.checkbox').mousedown();
          $j('td.date.overridable').find('a.checkbox').mouseup();
          var form = $('staffScheduleForm');
          showResources(form, form.action, 'eventInfo');
      },

      cancelStaffAvailabilityOverridingOnStaffSchedule: function() {
          closeModalForm();
          $j('td.date.overridable').removeClass('overridable');
      },

      clearStaffScheduleConfirmations: function() {
          var form = $j('#staffScheduleForm');
          form.find('[name="skipStaffAvailabilityCheck"]').val(0);
      },

      // instructor schedule on activities, see view-pro-schedule.phtml
      saveStaffSchedule: function() {
          this.clearStaffScheduleConfirmations();
          var containerName = 'eventInfo';
          var form = $('staffScheduleForm');
          showResources(form, form.action, containerName);
      },

      // resource time on activities
      saveGroupEventResourceTime: function(additionalSerializedParams = '', modalParams = {}) {
          var groupActivityResourcesForm = $('courtScheduleProperties');
          var formData = groupActivityResourcesForm.serialize();
          var url = groupActivityResourcesForm.action;
          url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';

          if (additionalSerializedParams) {
              if (formData.length > 0){
                  formData += '&';
              }
              formData += additionalSerializedParams;
          }

          showAjaxStarted();
          new Ajax.Request(
              url,
              {
                  method: 'post',
                  parameters: formData,
                  onComplete: function (response) {
                      var title = 'Save';
                      var width = 900;
                      var height = 330;
                      var disableAll = true;

                      if (response.responseText.indexOf('Le83bhY83hf6su53WdjeKje873jLl') > -1) {
                          title = 'Confirm Event Dates';
                      } else if (response.responseText.indexOf('staff-availability-overriding') > -1) {
                          title = 'Staff Not Available';
                          width = 425;
                          height = 100;
                      }

                      showResponseInModal(response, title, width, height, disableAll, modalParams);
                  },
                  onFailure: reportAjaxError
              }
          );
      },

      // resource time on activities
      confirmStaffAvailabilityOverridingOnActivityEditing: function() {
          closeModalForm();
          $j('#courtScheduleProperties').find('[name="skipStaffAvailabilityCheck"]').val(1);
          var additionalParams = $('confirm-reservation-options').serialize(); // from previous confirmation form
          this.saveGroupEventResourceTime(
              additionalParams,
              {
                  destroyOnClose: true
              }
          );
      },

      // 'select staff' on activity (grid on services)
      confirmStaffAvailabilityOverridingOnAttendanceProRoster: function(url) {
          closeModalForm();
          $j('#courtScheduleProperties').find('[name="skipStaffAvailabilityCheck"]').val(1);
          cpac.resource.selectPro.onSave(url);
      },

     reserveUserOverrideBookingConfirm: function(toggleButton, confirmations) {
         closeModalForm();
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';

         if (!confirmations) {
             confirmations = [];
         }
         confirmations.push('skipUserAvailability');
         confirmations.push('bookingRulesOverride');

         this.reserveCourtSave(
             {
                 toggle: toggleButton ? toggleButton : 'reserve-court-button',
                 url: url,
                 confirmations: confirmations
             },
             true
         );
     },
     
     reserveMemberConfirm: function(toggleButton) {
         closeModalForm();
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         url += '&skipMemberRestrictions=1';
         
         this.reserveCourtSave({
              toggle: toggleButton ? toggleButton : 'reserve-court-button'
             ,url: url
         }, true);
     },

     reserveUserOverrideBallmachineConfirm: function(toggleButton, confirmations) {
         closeModalForm();
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';

         if (!confirmations) {
             confirmations = [];
         }
         confirmations.push('skipMemberRestrictions');
         confirmations.push('overrideBallmachine');

         this.reserveCourtSave(
             {
                 toggle: toggleButton ? toggleButton : 'reserve-court-button',
                 url: url,
                 confirmations: confirmations
             },
             true
         );
     },
  
     reserveLessonPackageReallocationConfirm: function(toggleButton) {
         // required params added to form, just submit
         var form = $('courtScheduleProperties');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
  
         this.reserveCourtSave({
             toggle: toggleButton ? toggleButton : 'reserve-court-button',
             url: url
         }, true);
     },
  
     indoorRainCourtConfirm: function (toggleButton, value) {
         closeModalForm();
         var form = $('courtScheduleProperties');
         if (form.book_indoor_rain_court) {
             form.book_indoor_rain_court.value = value;
         }
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         this.reserveCourtSave({
              toggle: toggleButton ? toggleButton : 'private-lesson-button'
             ,url: url
         }, true);
     }
  
     ,reserveCourtSave: function( argv, dontDisplayError ) {
         if( Ajax.activeRequestCount || $j.active ) {
             var self = this;
             if( ! this.reserveCourtSaveBusyInterval ) {
                 this.reserveCourtSaveBusyInterval = setInterval(function(){
                     self.reserveCourtSave( argv, dontDisplayError );
                 }, 100);
             }
             return;
         }
         clearInterval( this.reserveCourtSaveBusyInterval );
         this.reserveCourtSaveBusyInterval = null;
  
         argv = argv || {};
  
         if( ! argv.toggle )
             argv.toggle = 'reserve-court-button';
  
         if( this.updating ){
             return;
         }
  
         var form = '';
         if( ! argv.form ) {
             form = $('courtScheduleProperties');
         } else {
             form = argv.form;
         }
  
         if( ! argv.dontParseGrid ) {
             if( ! parceCourtGreed( form.multiselectdata, dontDisplayError )){
                 return
             }
         }
  
         if( form.cancel )
             form.cancel.value = '0';
         if( form.save )
             form.save.value = '1';
  
         if( argv.beforeSubmit )  {
             if( argv.beforeSubmit( form ) === false ) {
                 return;
             }
         }
  
         var groupex = 0;
         var groupexValue = $j(form).find('[name=groupex]').val();
         if (groupexValue == 1) {
             groupex = 1;
         }
  
         this.updating = true;
  
         resourcesPropertiesForm = form;
         var formData = form ? $(form).serialize() : '';
         
         if (formData && argv.skipUserAvailability) {
             formData += '&skipUserAvailability=' + argv.skipUserAvailability;
         }

         var skipUserAvailabilityParamName = 'skipUserAvailability';
         if (formData.indexOf(skipUserAvailabilityParamName) < 0) {
             // user availability flag not found, recheck on the main form
             var skipUserAvailability = $j('#courtScheduleProperties')
                 .find('[name="' + skipUserAvailabilityParamName + '"]')
                 .val();
             if (skipUserAvailability === '1') {
                 formData += '&' + skipUserAvailabilityParamName + '=1';
             }
         }

         var skipStaffAvailabilityCheckParamName = 'skipStaffAvailabilityCheck';
         if (formData.indexOf(skipStaffAvailabilityCheckParamName) < 0) {
             var skipStaffAvailabilityCheck = $j('#courtScheduleProperties')
                 .find('[name="' + skipStaffAvailabilityCheckParamName + '"]')
                 .val();
             if (skipStaffAvailabilityCheck === '1') {
                 formData += '&' + skipStaffAvailabilityCheckParamName + '=1';
             }
         }

         if( ! argv.url ) {
             var url = form.action;
             url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         } else {
             var url = argv.url;
         }

         if (argv.confirmations) {
             for (var i = 0; i < argv.confirmations.length; i++) {
                 if (url.indexOf('?') == -1) {
                     url += '?';
                 }
                 url += '&' + argv.confirmations[i] +  '=1';
             }
         }

         showAjaxStarted();
  
         ajaxDiv = $('court-properties-container');
  
         new Ajax.Request( url, {
             method: 'POST',
             parameters: formData,
             onComplete: function(answer) {
                 if( argv.afterSubmit )  {
                     argv.afterSubmit( form, answer );
                 }
  
                 if( answer.responseText.indexOf('xH3fJdfK9jdwliUf3doiFdvoe8kDx') > 0 ) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Save', 1156, 600, undefined, {destroyOnClose: true});
                 } else
                 if( answer.responseText.indexOf('Ckd39vdWo03Cl2d3W4o72CIjN4GwD') > 0 ) {
                     cpac.tennis.updating = false;
                     showResponseInModal( answer, 'Reservation Summary', 660, 330 );
                 } else
                 if( answer.responseText.indexOf('fddaaa13bc2d872fa1fd14d59ff13ca5') > 0 ) {
                     cpac.tennis.updating = false;
                     showResponseInModal( answer, 'Warning', 460, 150 );
                 } else
                 if( answer.responseText.indexOf('Le83bhY83hf6su53WdjeKje873jLl') > 0 ) {
                     cpac.tennis.updating = false;
                     showResponseInModal( answer, 'Confirm Event Dates', 900, 330 );
                 } else
                 if( answer.responseText.indexOf('Fgr93Lcfj3Hrop8dm3ofWo94Pe9dX') > 0 ) {
                     cpac.tennis.updating = false;
                     showResponseInModal( answer, 'Warning', 420, 100 );
                 } else
                 if( answer.responseText.indexOf('ySck3qDfl7vEsf4xwQ2h91nUiJ7c4') > 0 ) {
                     cpac.tennis.updating = false;
                     if( ! $('ajaxResponseTempContainer')) {
                         $('court-properties-container').insert( new Element('div', {
                             id: 'ajaxResponseTempContainer'
                         }));
                     }
                     showResponse(answer, $('ajaxResponseTempContainer'));
                 } else
                 if (answer.responseText.indexOf('682f436ba7840abb027cb6a8a976605e') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Warning', 420, 100);
                 } else
                 if (answer.responseText.indexOf('36e9a2ecbcd3ddf087d99c80f0264aa0') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Warning - Booking Rules', 420, 100);
                 } else
                 if (answer.responseText.indexOf('be0504e8379bcf4a3de0ad9e1be27780') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Warning', 420, 100);
                 } else
                 if (answer.responseText.indexOf('383a3dfa47880fb4f272a7d8a07669de') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Warning', 420, 100);
                 } else
                 if (answer.responseText.indexOf('94faf56faf495c452da95a4f2aa2da54') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Warning', 420, 100);
                 } else
                 if( answer.responseText.indexOf('errWin.win.showCenter(true)') > 0 ) {
                     showResponse(answer, ajaxDiv);
                     cpac.tennis.updating = false;
                 } else
                 if( answer.responseText.indexOf('wkrfg39dhtlHRFlws628GHherw23t') > 0 ) {
                     // redirect on the page
                     showResponse(answer, ajaxDiv);
                 } else if (answer.responseText.indexOf('package_reallocation_form') > 0) {
                     showResponse(answer, $('confirmationDiv'));
                     cpac.tennis.updating = false;
                 } else if (answer.responseText.indexOf('staff-availability-overriding') > 0) {
                     cpac.tennis.updating = false;
                     showResponseInModal(answer, 'Staff Not Available', 425, 100);
                 } else {
                     showResponse(answer, ajaxDiv);
  
                     var courtsInfoUrl = cpac.tennis.baseUrl+'resource/court-schedule';
                     if (groupex) {
                         courtsInfoUrl += '?groupex=1';
                     }
                     showResources($('courtScheduleProperties'), courtsInfoUrl, 'courtsInfo', function(){
                         cpac.tennis.updating = false;
                         if ($( argv.toggle )) {
                             $( argv.toggle ).toggleClassName('active');
                         }
                         if ($('edit-button')) {
                             $('edit-button').show();
                         }
                     });
                 }
             },
             onFailure: reportAjaxError
         });
     },
  
     clearConfirmations: function() {
         $j('#confirmationDiv').html(''); // clear confirmation hiddens

         var courtSchedulePropertiesForm = $j('#courtScheduleProperties');
         courtSchedulePropertiesForm.find('[name="skipStaffAvailabilityCheck"]').val(0);
         courtSchedulePropertiesForm.find('[name="skipUserAvailability"]').val(0);
     },
  
     memberOverrideDates: function () {
         var frame = window.searchSaleFrame;
         if(!frame) {
             frame = new (Class.create({
                 initialize: function() {
                     this.win = null;
                     //this._initWindow();
                 },
                 _initWindow: function() {
                     this.win = Windows.getWindow(window.searchSaleWindowId);
                     if(!this.win) {
                         this.win = new Window({
                             className: 'alphacube',
                             title: 'Override dates',
                             width: 350,
                             height: 150,
                             closable: true,
                             resizable: false,
                             minimizable: false,
                             maximizable: false,
                             destroyOnClose: true,
                             onDestroy: function(){
                                 $('court-properties-container').insert($('reserve-permanent-override-dates').setStyle({display: 'none'}));
                                 window.searchSaleWindowId = null;
                                 window.searchSaleFrame = null;
                             }
                         });
                         window.searchSaleWindowId = this.win.getId();
                     }
  
                     var formContainer = this.win.getContent();
                     var form = formContainer.down('#reserve-permanent-override-dates');
                     if(!form) {
                         //form = new Element('div', {id:'search-results'});
                         form = $('reserve-permanent-override-dates');
                         formContainer.insert(form);
                         form.show();
  
                         var btnCancel = form.down('#button-sale-cancel');
                         if(btnCancel) {
                             btnCancel.observe('click', function() {Windows.close(this.win.getId());}.bind(this));
                         }
                         var btnSearch = form.down('#button-sale-search');
                         if(btnSearch) {
                             btnSearch.observe('click', function() {this.searchSale();}.bind(this));
                         }
                     }
  
                     return form;
                 },
  
                 showForm: function() {
                     this._initWindow();
                     this.win.showCenter(true);
                 },
  
                 searchSale: function() {try {
                     var form = this._initWindow();
                     var pf = $('courtScheduleProperties');
  
                     if( form.down('#overrided_start_date').getValue() != '' ) {
                         $(pf.date).setValue( form.down('#overrided_start_date').getValue() );
                         $(pf.date).enable();
                         $('lblReserveSeasonRange').down('span', 0).update( pf.date.value );
                     }
  
                     if( form.down('#overrided_end_date').getValue() != '' ) {
                         $(pf.end_date).setValue( form.down('#overrided_end_date').getValue() );
                         $(pf.end_date).enable();
                         $('lblReserveSeasonRange').down('span', 1).update( pf.end_date.value );
                     }
  
                     Windows.close(this.win.getId());
                 }
                 catch(e) { cpac.error(e)}}
             }));
             window.searchSaleFrame = frame;
         }
         frame.showForm();
     }
  
     ,trainerOverrideDates: function () {
         var frame = window.trainerOverrideDatesFrame;
         if(!frame) {
             frame = new (Class.create({
                 initialize: function() {
                     this.win = null;
                     //this._initWindow();
                 },
                 _initWindow: function() {
                     this.win = Windows.getWindow(window.trainerOverrideDatesWindowId);
                     if(!this.win) {
                         this.win = new Window({
                             className: 'alphacube',
                             title: 'Override dates',
                             width: 350,
                             height: 150,
                             closable: true,
                             resizable: false,
                             minimizable: false,
                             maximizable: false,
                             destroyOnClose: true,
                             onDestroy: function(){
                                 $('court-properties-container').insert($('trainer-permanent-override-dates').setStyle({display: 'none'}));
                                 window.searchSaleWindowId = null;
                                 window.searchSaleFrame = null;
                             }
                         });
                         window.trainerOverrideDatesWindowId = this.win.getId();
                     }
  
                     var formContainer = this.win.getContent();
                     var form = formContainer.down('#trainer-permanent-override-dates');
                     if(!form) {
                         form = $('trainer-permanent-override-dates');
                         formContainer.insert(form);
                         form.show();
  
                         var btnCancel = form.down('#trainer-rpdo-cancel');
                         if(btnCancel) {
                             btnCancel.observe('click', function() {Windows.close(this.win.getId());}.bind(this));
                         }
                         var btnSearch = form.down('#trainer-rpdo-save');
                         if(btnSearch) {
                             btnSearch.observe('click', function() {this.searchSale();}.bind(this));
                         }
                     }
  
                     return form;
                 },
  
                 showForm: function() {
                     this._initWindow();
                     this.win.showCenter(true);
                 },
  
                 searchSale: function() {try {
                     var form = this._initWindow();
                     var pf = $('courtScheduleProperties');
                     var _date = form.down('#trainer_overrided_date').getValue();
  
                     if( _date != '' ) {
                         $('trainerStartDate').setValue( _date );
                         $('lblTrainerStartDate').down('span', 0).update( _date );
                         // update _date in court properties
                         if (pf && my_isset(pf.date)) {
                             pf.date.setValue(_date);
                             $(pf.date).enable();
                         }
                         // update day of week in court properties
                         var dObj = cpacDate.getDateObject(_date);
                         var dayOfWeek = dObj.getDay();
                         if (dayOfWeek == 0) {
                             dayOfWeek = 7;
                         }
                         var dowRow = $('daysOfWeekSelect_row_' + dayOfWeek);
                         if (dowRow) {
                             dowRow.onclick();
                         }
                         // update date for date range
                         $('lblReserveSeasonRange').down('span', 0).update( pf.date.value );
  
  
                     }
  
                     Windows.close(this.win.getId());
                 }
                 catch(e) {cpac.error(e)}}
             }));
             window.trainerOverrideDatesFrame = frame;
         }
         frame.showForm();
     }
  
     ,toggleBallPlan: function()
     {
         if( $('ball_plan').value == '1' )
         {
             $('ball-plan-on').hide();
             $('ball-plan-off').show();
             $('ball_plan').value = '0';
             $('ball_plan_cnt_box').hide();
         } else {
             $('ball-plan-on').show();
             $('ball-plan-off').hide();
             $('ball_plan').value = '1';
             $('ball_plan_cnt_box').show();
         }
     }
     
     ,onChangeBallPlanCans: function (inputObj)
     {
         var cansValue = parseFloat(inputObj.value);
         if (isNaN(cansValue) || cansValue < 1) {
             cansValue = 1;
         }
         inputObj.value = cansValue
     }
  
     ,toggleSeasonBilling: function()
     {
         $('custom-billing').visible() ? $('custom-billing').hide() : $('custom-billing').show();
         return false;
     }
  
     ,setSeasonCustomBilling: function()
     {
         var fPrice = $('season_price');
         var fType  = $('season_price_type');
  
         if( fPrice && fType )
         {
             switch( fType.value ) {
                 case 'per_hour' :$('lblSeasonPriceType').update('(Per Hour)');break;
                 case 'full'     :$('lblSeasonPriceType').update('(Per Court/Person)');break;
             }
  
             if( ! isNaN( fPrice.value )) {
                $('lblSeasonPrice').update( '$' + fPrice.value );
             } else {
                 $('lblSeasonPrice').update('Default Rate');
                 fPrice.value = '-default-';
             }
         }
  
         $('custom-billing').hide();
     }
     ,setSeasonBillingType: function (typeValue, prefix)
     {
         $('season_price').removeAttribute('readonly');
         if (typeValue == 'full') {
             $(prefix + 'UserPriceType').value = '%';
         } else if (typeValue == 'season') {
             $(prefix + 'UserPriceType').value = '$';
             $('season_price').setAttribute('readonly', 'readonly');
             $('season_price').value = '-default-';
         }
     }
     ,setLeagueBillingType: function (typeValue)
     {
        var toHide, toShow;
         $('season_price').removeAttribute('readonly');
         if (typeValue == 'season') {
             // hide # of times for new users and show $ amount for custom fee
             toHide = $('tennis_page').select('.player-times');
             toShow = $('tennis_page').select('.player-percent');
  
             toHide.each(function(el){
                 $(el).hide();
             });
             toShow.each(function(el){
                 $(el).show();
             });
         } else {
             // hide $ amount for custom fee for new users and show # of times
             toHide = $('tennis_page').select('.player-percent');
             toShow = $('tennis_page').select('.player-times');
  
             toHide.each(function(el){
                 $(el).hide();
             });
             toShow.each(function(el){
                 $(el).show();
             });
         }
     }
  
     ,toggleSeasonReservationType: function() {try {
         var select  = $('reserv_type');
  
         var newName = select.value;
         var oldName = newName == 'member' ? 'trainer' : 'member';
  
         var toHide = $('tennis_page').select('.reserve-only-for-' + oldName);
         var toShow = $('tennis_page').select('.reserve-only-for-' + newName);
  
         toHide.each(function(el){
             $(el).hide();
         });
         toShow.each(function(el){
             $(el).show();
         });
     }
     catch(e) {cpac.error(e)}}
  
     ,toggleRainReservationType: function() {try {
         var select  = $('raincourt_type');
  
         var newName = select.value;
         var oldName = newName == 'member' ? 'event' : 'member';
  
         if( $j('#reserve-rain-court-cell-1').is('td')) {
             if( newName == 'member' ) {
                 $j('#reserve-rain-court-cell-1').attr('width', 185).css({width: '185px', minWidth: '185px'});
                 $j('#reserve-rain-court-cell-2').attr('width', 100).css({width: '100px', minWidth: '100px'});
             }else {
                 $j('#reserve-rain-court-cell-1').attr('width', 430).css({width: '430px', minWidth: '430px'});
                 $j('#reserve-rain-court-cell-2').attr('width', 165).css({width: '165px', minWidth: '165px'});
             }
         }
  
         var toHide = $('tennis_page').select('.reserve-only-for-' + oldName);
         var toShow = $('tennis_page').select('.reserve-only-for-' + newName);
  
         toHide.each(function(el){
             $(el).hide();
         });
         toShow.each(function(el){
             $(el).show();
         });
     }
     catch(e) {cpac.error(e)}}
  
   ,addPermanent: function( id, name, price, type, replace, nobuttons ){try {
         if( ! id ) {
             id = new String($('rpUserId').value);
         }
     var newDivId = 'rpPlayer' + id;
  
     // check if such player already exists
     if (id > 0 && $(newDivId) == null)
     {
             // price
             if( ! price ) {
                 price = $('rpUserPrice').value;
             }
             if( isNaN( price )) {
                 price = '';
             }
             // price type: % or $
             if( ! type ) {
                 type = $('rpUserPriceType').value;
             }
             if( ! type ) {
                 type = '%';
             }
  
  
       if ($('rpHiddenPlayerList').value == '') {
         $('rpHiddenPlayerList').value = id;
         if( $('rpNone') ) {
                     $('rpAddedPlayers').removeChild($('rpNone'));
                 }
       } else {
         $('rpHiddenPlayerList').value += ',' + id;
       }
  
             if( ! name ) {
                 name = $('rpUserName').value;
             }
  
             var playerString = document.createElement("div");
             playerString.className = 'player-item-box';
             playerString.id = newDivId;
             var echo = '';
  
             echo += '<div class="fb-user-box">';
             if (!my_isset(nobuttons)) {
                 echo += '<a onclick="cpac.tennis.removePlayer('+id+', '+"'rp'"+');" href="javascript:void(0)" class="fb-user-box-close"></a>';
             }
             echo += '<a href="/user/edit/?id='+id+'" class="fb-user-box-title">'+name+'</a>';
             echo += '</div>';
  
             if (!my_isset(nobuttons)) {
                 // select $ or %
                 var selected1 = type == '$' ? '' : ' selected';
                 var selected2 = type == '$' ? ' selected' : '';
                 echo +=
                 '<div class="rpUserPriceType">' +
           '<div class="cs-select left-oriented" style="width: 46px;">' +
             '<select style="width: 67px; margin: 0px; background-position: 30px 50%;" class="perm_fee_type" id="p_type_'+id+'" name="p_type_'+id+'" onchange="$j(\'.perm_fee_type\').val($j(this).val()); $j(\'#rpUserPriceType\').val($j(this).val());">' +
               '<option label="" value="%" ' + selected1 + '>%</option>' +
               '<option label="" value="$" ' + selected2 + '>$</option>' +
             '</select>' +
           '</div>';
                 //    '<div id="p_type_'+id+'-select-caption" class="select report-select" style="width: 46px !important;" onclick="formSelect.toggle(\'hidden_filter_p_type_'+id+'\');">' +
                 //        '<div class="select-arrow">' +
                 //            '<div id="filter-description" class="right-oriented"></div>' +
                 //            '<strong>' + type + '</strong>' +
                 //        '</div>' +
                 //    '</div>' +
                 //    '<div id="hidden_filter_p_type_'+id+'" class="hidden-filter " style="overflow: visible; display: none; width: 58px !important;">' +
                 //        '<div class="row-block">' +
                 //             '<a id="p_type_'+id+'_row_%" class="row ' + selected1 + '" href="javascript:void(0)" onclick="formSelect.selectOption(this, this.parentNode.parentNode, \'p_type_'+id+'\', \'%\', 1)">%<div class="comment"></div></a>' +
                 //        '</div>' +
                 //        '<div class="row-block">' +
                 //            '<a id="p_type_'+id+'_row_$" class="row ' + selected2 + '" href="javascript:void(0)" onclick="formSelect.selectOption(this, this.parentNode.parentNode, \'p_type_'+id+'\', \'$\', 1)">$<div class="comment"></div></a>' +
                 //        '</div>' +
                 //    '</div>' +
                 //    '<input type="hidden" id="p_type_'+id+'" name="p_type_'+id+'" value="'+type+'" />' +
                 '</div>';
  
                 echo += '<div class="player-percent">';
                 echo += `<input class="field thin-border"
                                 type="text"
                                 id="percent_${id}"
                                 name="percent_${id}"
                                 value="${price != '' ? price : '-default-'}"
                                 onclick="if (this.value == '-default-') {this.value = ''}"
                                 onblur="if (this.value == '') {this.value = '-default-'}"
                                 style="width: 48px;"
                          />`;
                 echo += '</div>';
             } else {
                 echo += '<div style="height: 21px; line-height: 23px; font-size: 12px;">';
                 echo += type == '$' ? '$'+price : price+''+type;
                 echo += '</div>';
                 echo += '<input type="hidden" id="p_type_'+id+'" name="p_type_'+id+'" value="'+type+'" />';
                 echo += '<input type="hidden" id="percent_'+id+'" name="percent_'+id+'" value="'+price+'" />';
             }
  
             /*
       var playerString = document.createElement("div");
       playerString.className = 'player-item';
       playerString.id = newDivId;
       playerString.innerHTML += '<span class="player-name">'+ name +'</span>';
             if (price == '') {
                 playerString.innerHTML += '<span> </span>';
             } else {
                 playerString.innerHTML += type == '$' ? ' <span>($'+ price +')</span> ' : ' <span>('+ price +'%)</span> ';
             }
       //playerString.innerHTML += price == '' ? '<span> </span>' : ' <span>('+ price +'%)</span> ';
       if (!my_isset(nobuttons)) {
           playerString.innerHTML += ' &nbsp; <a href="javascript:void(0)" onclick="cpac.tennis.removePlayer('+ id +', '+"'rp'"+');">remove</a>';
                 playerString.innerHTML += '&nbsp; <a href="javascript:void(0)" onclick="cpac.tennis.editPermanent('+ id +');">edit</a>';
             }
             playerString.innerHTML += '<input type="hidden" id="p_type_'+id+'" name="p_type_'+id+'" value="'+type+'" />';
       playerString.innerHTML += '<input type="hidden" id="percent_'+id+'" name="percent_'+id+'" value="'+price+'" />';
  
             */
  
             playerString.innerHTML = echo;
             if( ! replace ) {
                 $('rpAddedPlayers').appendChild(playerString);
                 $('rpUserName').value = '';
                 $('rpUserId').value = '';
                 //$('rpUserPriceType').value = '%'; // don't set to default
                 $('rpUserPrice').value = '-default-';
                 if( $('rpUserSearchBox')) {
                     $('rpUserSearchBox').hide();
                 }
             } else {
                 replace.insert({after: playerString});
             }
  
       return true;
     } else {
       return false;
     }
   }
   catch(e) {cpac.error(e)}}
  
     ,addLeaguePlayer: function( id, name, price, times, replace, nobuttons, number ){try {
         if( ! id ) {
             id = new String($('rlUserId').value);
         }
     var newDivId = 'rlPlayer' + id;
  
     // check if such player already exists
     if (id > 0 && $(newDivId) == null)
     {
             // price
             if( ! price ) {
                 price = $('rlUserPrice').value;
             }
  
             if( isNaN( price ) && price != cpac.tennis.defaultPrice) {
                 price = '';
             }
  
             // # of times
             if( ! times ) {
                 times = $('rlUserTimes').value;
             }
             if( ! times ) {
                 times = 'auto';
             }
  
  
       if ($('rlHiddenPlayerList').value == '') {
         $('rlHiddenPlayerList').value = id;
         if( $('rlNone') ) {
                     $('rlAddedPlayers').removeChild($('rlNone'));
                 }
       } else {
         $('rlHiddenPlayerList').value += ',' + id;
       }
  
             if( ! name ) {
                 name = $('rlUserName').value;
             }
             if( ! number ) {
                 number = $('rlUserNumber').value;
             }              
  
             var playerString = document.createElement("div");
             playerString.className = 'player-item-box';
             playerString.id = newDivId;
             var echo = '';
  
             echo += '<div class="fb-user-box">';
             if (!my_isset(nobuttons)) {
                 echo += '<a onclick="cpac.tennis.removePlayer('+id+', '+"'rl'"+');" href="javascript:void(0)" class="fb-user-box-close"></a>';
             }
             echo += '<a href="/user/edit/?id='+id+'" class="fb-user-box-title">'+name+'</a>';
             echo += '</div>';
  
             var percentVisible = $('season_price_type') && $('season_price_type').value == 'season';
             var timesVisible = !percentVisible;
             if (!my_isset(nobuttons)) {
                 // # of times
                 echo += '<div class="player-times" ' + (timesVisible ? '' : ' style="display: none;" ') + '>';
                 echo += ' # of times ';
                 echo += '<input class="field thin-border" type="text" id="times_'+id+'" name="times_'+id+'" value="'+times+'" style="width: 48px;" onblur="if (this.value == \'\') this.value=\'auto\'" onfocus="if (this.value == \'auto\') this.value=\'\'"  />';
                 
                 echo += ' Player Number ';
                 echo += '<input class="field thin-border" type="text" id="number_'+id+'" name="number_'+id+'" value="'+number+'" style="width: 48px;"  />';                
                 echo += '</div>';
  
                 // $ amount
                 echo += '<div class="player-percent" ' + (percentVisible ? '' : ' style="display: none;" ') + '>';
                 echo += '$';
                 echo += '<input class="field thin-border" type="text" id="percent_'+id+'" name="percent_'+id+'" value="'+price+'" style="width: 48px;" onfocus="if (this.value == \'' + cpac.tennis.defaultPrice + '\') {this.value = \'\';}" />';
                 echo += '</div>';
             } else {
                 echo += '<div style="height: 21px; line-height: 23px; font-size: 12px;">';
                 echo += percentVisible ? '$'+price : '# of times: ' + times;
                 echo += '</div>';
                 echo += '<input type="hidden" id="times_'+id+'" name="times_'+id+'" value="'+times+'" />';
                 echo += '<input type="hidden" id="percent_'+id+'" name="percent_'+id+'" value="'+price+'" />';
             }
  
             playerString.innerHTML = echo;
             if( ! replace ) {
                 $('rlAddedPlayers').appendChild(playerString);
                 $('rlUserName').value = '';
                 $('rlUserId').value = '';
                 //$('rlUserPriceType').value = '%'; // don't set to default
                 $('rlUserNumber').value = '';
                 $('rlUserPrice').value = '';
                 $('rlUserTimes').value = 'auto';
                 if( $('rlUserSearchBox')) {
                     $('rlUserSearchBox').hide();
                 }
             }else {
                 replace.insert({after: playerString});
             }
  
       return true;
     } else {
       return false;
     }
   }
   catch(e) {
         cpac.error(e);
     }},
     addLeagueSubstitutionPlayer: function( id, name, number, comment, replace, nobuttons ){try {
         if( ! id ) {
             id = new String($('substUserId').value);
         }
     var newDivId = 'substPlayer' + id;
  
     // check if such player already exists
     if (id > 0 && $(newDivId) == null)
     {
                   if ($('substHiddenPlayerList').value == '') {
         $('substHiddenPlayerList').value = id;
         if( $('substNone') ) {
                     $('substAddedPlayers').removeChild($('substNone'));
                 }
       } else {
         $('substHiddenPlayerList').value += ',' + id;
       }
  
             if( ! name ) {
                 name = $('substUserName').value;
             }
             if( ! number ) {
                 number = $('substUserNumber').value;
             }    
             if( ! comment ) {
                 comment = $('substUserComment').value;
             }              
  
             var playerString = document.createElement("div");
             playerString.className = 'player-item-box';
             playerString.id = newDivId;
             var echo = '';
  
             echo += '<div class="fb-user-box">';
             if (!my_isset(nobuttons)) {
                 echo += '<a onclick="cpac.tennis.removePlayer('+id+', '+"'subst'"+');" href="javascript:void(0)" class="fb-user-box-close"></a>';
             }
             echo += '<a href="/user/edit/?id='+id+'" class="fb-user-box-title">'+name+'</a>';
             echo += '</div>';
  
             var percentVisible = $('season_price_type') && $('season_price_type').value == 'season';
             var timesVisible = !percentVisible;
             if (!my_isset(nobuttons)) {
                 // # of times
                 echo += '<div class="player-number" ' + (timesVisible ? '' : ' style="display: none;" ') + '>';
                 echo += ' Player Number ';
                     echo += '<input class="field thin-border" type="text" id="number_'+id+'" name="number['+id+']" value="'+number+'" style="width: 48px; margin:0px;" />';
                 echo += ' Comments ';
                     echo += '<input class="field thin-border" type="text" id="comment_'+id+'" name="comment['+id+']" value="'+comment+'" style="width: 400px; margin:0px;" />';                
                 echo += '</div>';
             } 
             playerString.innerHTML = echo;
             if( ! replace ) {
                 $('substAddedPlayers').appendChild(playerString);
                 $('substUserName').value = '';
                 $('substUserId').value = '';
  
  
                 if( $('substUserSearchBox')) {
                     $('substUserSearchBox').hide();
                 }
             }else {
                 replace.insert({after: playerString});
             }
  
       return true;
     } else {
       return false;
     }
   }
   catch(e) {cpac.error(e)}}
  
     ,editPermanent: function(id){try {
         var playerItem = $('rpPlayer'+id);
         if( playerItem ) {
             var playerName      = playerItem.down('.player-name').innerHTML;
             var playerPercent   = playerItem.down('[name="percent_'+id+'"]').value;
             var playerPaymentType   = playerItem.down('[name="p_type_'+id+'"]').value;
  
       var playerString = document.createElement("div");
       playerString.className = 'player-item-edit';
             playerString.id = 'rpEditPlayer'+id;
             var echo = '';
             echo += '<div class="player-name">Player name&nbsp;';
             echo += '<input id="rpUserEditName'+id+'" type="text" class="field" value="'+playerName+'" onFocus="nameFieldOnFocus('+"'rpUserEditName"+id+"', 'rpUserEditId"+id+"', null, 1, null, null, 1);"+'" />';
             echo += '</div>';
                 // select $ or %
             var selected1 = playerPaymentType == '$' ? '' : ' selected';
             var selected2 = playerPaymentType == '$' ? ' selected' : '';
             echo += '<div class="rpUserPriceType" >' +
                       '<div id="rpUserEditPriceType'+id+'-select-caption" class="select " onclick="formSelect.toggle(\'hidden_filter_rpUserEditPriceType'+id+'\');">' +
                         '<div class="select-arrow">' +
                           '<div id="filter-description" class="right-oriented"></div>' +
                           '<strong>' + playerPaymentType + '</strong>' +
                         '</div>' +
                       '</div>' +
                       '<div id="hidden_filter_rpUserEditPriceType'+id+'" class="hidden-filter " style="overflow: visible; display: none;">' +
                         '<div class="row-block">' +
                           '<a id="rpUserEditPriceType'+id+'_row_%" class="row ' + selected1 + '" href="javascript:void(0)" onclick="formSelect.selectOption(this, this.parentNode.parentNode, \'rpUserEditPriceType'+id+'\', \'%\', 1)">%<div class="comment"></div></a>' +
                         '</div>' +
                         '<div class="row-block">' +
                           '<a id="rpUserEditPriceType'+id+'_row_$" class="row ' + selected2 + '" href="javascript:void(0)" onclick="formSelect.selectOption(this, this.parentNode.parentNode, \'rpUserEditPriceType'+id+'\', \'$\', 1)">$<div class="comment"></div></a>' +
                         '</div>' +
                       '</div>' +
                       '<input name="rpUserEditPriceType'+id+'" value="' + playerPaymentType + '" onchange="" id="rpUserEditPriceType'+id+'" type="hidden">' +
                     '</div>';
             echo += '<div class="player-percent">';
             echo += '<input class="field" type="text" id="rpUserEditPercent'+id+'" value="'+playerPercent+'" />';
             echo += '</div>';
             echo += '<div class="player-save-changes">';
             echo += '<button class="button nicebutton" type="button" value="Save" onclick="cpac.tennis.saveEditPermanent('+id+');">Save</button>';
             echo += '</div>';
             echo += '<input type="hidden" id="rpUserEditId'+id+'" value="'+id+'">';
  
             playerString.innerHTML = echo;
             playerItem.hide();
             playerItem.insert({after: playerString});
         }
     }
     catch(e){cpac.error(e)}}
  
     ,saveEditPermanent: function(id) {try {
         var newid   = $('rpUserEditId'+id).getValue();
         var name    = $('rpUserEditName'+id).getValue();
         var vType = $('rpUserEditPriceType'+id).getValue();
         var value = $('rpUserEditPercent'+id).getValue();
  
         if( newid != id ) {
             if( ! this.addPermanent( newid, name, value, value, $('rpPlayer'+id ))) {
                 return;
             }
             this.removePlayer(id, 'rp');
         } else if( isNaN( value )) {
             return;
         } else {
             var playerItem = $('rpPlayer'+id);
  
             if( value == '' ) {
                 playerItem.down(1).update(' ');
             } else if (vType == '$') {
                 playerItem.down(1).update(' ($'+value+') ');
             } else {
                 playerItem.down(1).update(' ('+value+'%) ');
             }
  
             $('percent_'+id).setValue(value);
             $('p_type_'+id).setValue(vType);
  
             playerItem.show();
         }
         $('rpEditPlayer'+id).remove();
     }
     catch(e){cpac.error(e)}}
  
   ,permanentPlayer: function(){try {
     if( ! $('rpUserSearchBox').visible() ){
       $('rpUserSearchBox').show();
     } else {
       $('rpUserSearchBox').hide();
     }
   }
   catch(e) {cpac.error(e)}}
  
     ,permanentCourtSave: function( dontDisplayError, url ) {try {
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         var weekDays = new Array();
         weekDays[0] = daysOfWeekCourt.value;
         $('currentWeekDays').value = weekDays;
         $('dayOfWeekArray').value = weekDays[0];
  
         this.reserveCourtSave({
              url: url ? url : null
             ,toggle: 'reserve-permanent-button'
             ,beforeSubmit: function( form ) {
                 if( form.ball_plan != undefined && $F(form.ball_plan) == 0 ) {
                     form.ball_plan.disable();
                 }
  
                 if( $F(form.reserv_type) == 'member' ) {
                     if ($('rcUserId')) $('rcUserId').disable();
                     if ($('rcHiddenPlayerList')) $('rcHiddenPlayerList').disable();
                 } else {
                     if ($('rpUserId')) $('rpUserId').disable();
                     if ($('rpHiddenPlayerList')) $('rpHiddenPlayerList').disable();
                 }
  
                 return true;
             }
             ,afterSubmit: function( form ) {try {
                 if ( form.ball_plan) {
                     form.ball_plan.enable();
                 }
  
                 if( $('rcUserId'))
                     $('rcUserId').enable();
                 if( $('rcHiddenPlayerList'))
                     $('rcHiddenPlayerList').enable();
                 if( $('rpUserId'))
                     $('rpUserId').enable();
                 if( $('rpHiddenPlayerList'))
                     $('rpHiddenPlayerList').enable();
             }
             catch(e){cpac.error(e)}}
         }, dontDisplayError );
     }
     catch(e){cpac.error(e)}}
  
     ,permanentCourtConfirmOverride: function() {try {
         var form = $('confirm-reservation-options');
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         url += '&confirmed_ar=1';
         var sesskey = $j('#sessKey').val();
         if (sesskey) {
             url += '&sessKey=' + sesskey;
         }
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         var weekDays = new Array();
         weekDays[0] = daysOfWeekCourt.value;
         $('currentWeekDays').value = weekDays;
         $('dayOfWeekArray').value = weekDays[0];
  
         this.reserveCourtSave({
              url: url ? url : null
             ,toggle: 'reserve-permanent-button'
             ,dontParseGrid: true
             ,form: form
             ,afterSubmit: function(){
                 closeModalForm();
             }
         });
     }
     catch(e){cpac.error(e)}}
  
     ,permanentCourtConfirm: function(toggle, isUserCheck, usePropertyForm, isMemberCheck, skipStaffAvailabilityCheck = false) {try {
         var form = $('confirm-reservation-options');
         if ((isUserCheck && !form) || my_isset(usePropertyForm)) { 
             form = $('courtScheduleProperties');
         }
         var url = form.action;
         url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
         var sesskey;
         if (isUserCheck) {
             url += '&skipUserAvailability=1&confirmed_ar=1';
             sesskey = $j('#sessKey').val();
             if (sesskey) {
                 url += '&sessKey=' + sesskey;
             }
         } else if (my_isset(usePropertyForm)) {
             url += '&confirmed_ar=1';
             sesskey = $j('#sessKey').val();
             if (sesskey) {
                 url += '&sessKey=' + sesskey;
             }
         } else if (isMemberCheck) {
             url += '&skipMemberRestrictions=1';
             sesskey = $j('#sessKey').val();
             if (sesskey) {
                 url += '&sessKey=' + sesskey;
             }
         } else if (skipStaffAvailabilityCheck) {
             sesskey = $j('#sessKey').val();
             if (sesskey) {
                 url += '&sessKey=' + sesskey;
             }
             $j('#courtScheduleProperties').find('[name="skipStaffAvailabilityCheck"]').val(1);
         }

         if($j(form).find('[name=confirmed_ar]').val()) {
             url += '&confirmed_ar=1';
         }
  
         $j('#confirmationDiv').find('input').each(function(){
             url += '&' + $j(this).attr('id') + '=' + $j(this).val();
         });
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         var weekDays = new Array();
         weekDays[0] = daysOfWeekCourt.value;
         $('currentWeekDays').value = weekDays;
         $('dayOfWeekArray').value = weekDays[0];
  
         this.reserveCourtSave({
              url: url ? url : null
             ,toggle: toggle ? toggle : 'reserve-permanent-button'
             ,dontParseGrid: true
             ,form: form
             ,afterSubmit: function(){
                 closeModalForm();
             }
         });
     }
     catch(e){cpac.error(e)}}
  
     ,blockTimeSave: function( dontDisplayError ) {try {
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         var weekDays = new Array();
         weekDays[0] = daysOfWeekCourt.value;
         $('currentWeekDays').value = weekDays;
         $('dayOfWeekArray').value = weekDays[0];
  
         this.reserveCourtSave({
              toggle: 'reserve-block-button'
         }, dontDisplayError );
     }
     catch(e){cpac.error(e)}}
  
     ,rainCourtSave: function( dontDisplayError ) {try {
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         var weekDays = new Array();
         weekDays[0] = daysOfWeekCourt.value;
         $('currentWeekDays').value = weekDays;
         $('dayOfWeekArray').value = weekDays[0];
  
         this.reserveCourtSave({
              toggle: 'rain-court-button'
             ,beforeSubmit: function() {
                 $('rpUserId').disable();
                 $('rpHiddenPlayerList').disable();
                 return true;
             }
             ,afterSubmit: function() {try {
                 if( $('rcUserId'))
                     $('rcUserId').enable();
                 if( $('rcHiddenPlayerList'))
                     $('rcHiddenPlayerList').enable();
                 if( $('rpUserId'))
                     $('rpUserId').enable();
                 if( $('rpHiddenPlayerList'))
                     $('rpHiddenPlayerList').enable();
             }
             catch(e){cpac.error(e)}}
         }, dontDisplayError );
     }
     catch(e){cpac.error(e)}}
  
     ,refreshReservePermanent: function() {try {
  
         var form = $('courtScheduleProperties');
  
         if(!( $F(form.date) && $('overrided_start_date').value != '' )) {
             form.date.disable();
         }
  
         if(!( $F(form.end_date) && $('overrided_end_date').value != '' )) {
             form.end_date.disable();
         }
  
         var daysOfWeekCourt = $('daysOfWeekSelect');
         $('dayOfWeekArray').value = daysOfWeekCourt.value;
  
         showResources( form, cpac.tennis.baseUrl+'resource/court-schedule' , 'courtsInfo', function(){
             $('reserve-permanent-right-menu').show();
             form.date.enable();
             form.end_date.enable();
         });
     }
     catch(e){cpac.error(e);}}
  
     ,showPaymentPlan: function () {try {
         var curPlan = $('rcPaymentPlan');
         showModalForm('Payment Plan', curPlan, 400, 100, false);
         var newPlan = modalWin.getContent().down('#rcPaymentPlanContent');
  
         var curInputs = curPlan.getElementsByTagName('input');
         var newInputs = newPlan.getElementsByTagName('input');
         for (var i=0; i < newInputs.length; i++) {
       newInputs[i].value = curInputs[i].value;
       newInputs[i].setAttribute('value', curInputs[i].value);
     }
     modalWin.updateHeight();
   }
     catch(e){cpac.error(e);}}
  
     ,generatePaymentPlan: function (count, divObj) {try {
         var pf = $('courtScheduleProperties');
         var startDate = pf.date.value;
         var endDate = pf.end_date.value;
  
         var sDate = cpacDate.getDateObject(startDate);
         var eDate = cpacDate.getDateObject(endDate);
  
         var sTime = sDate.getTime();
         var eTime = eDate.getTime();
  
         var secCount = eTime - sTime;
         var secPerPeriod = Math.floor(secCount / count);
  
         var sMonth = sDate.getMonth() + 1;
         var eMonth = eDate.getMonth() + 1;
         if (eMonth < sMonth) {
       eMonth = eMonth + 12;
     }
     var monthCount = eMonth - sMonth;
     var tryFirstDay;
     if (monthCount >= count) {
       tryFirstDay = true;
     } else {
       tryFirstDay = false;
     }
  
  
         var days = new Array();
         days[0] = startDate;
         for (var i=1; i < count; i++) {
       sDate.setTime(sDate.getTime() + secPerPeriod);
       if (tryFirstDay) {
         var tmpDate = new Date(sDate);
         tmpDate.setDate(1);
         if (sDate.getDate() > 15) {
           tmpDate.setMonth(tmpDate.getMonth() + 1);
         }
         sDate = tmpDate;
         days[i] = cpacDate.getDate(tmpDate);
       } else {
         days[i] = cpacDate.getDate(sDate);
       }
     }
  
     var daysDiv = $(divObj).down('.payment_plan');
     var html = '';
     for (i = 0; i < days.length; i++) {
       var num = i + 1;
       html += '<div class="label">Payment ' + num + ': </div>';
       html += '<input type="text" class="field date" name="payment_plan[days][' + i + ']" ' +
           'readonly="readonly" value="' + days[i] + '"/>';
       html += '<button onclick="displayCalendar(this.previousSibling,\'' + cpacDate.dateFormat + '\', this.previousSibling);" ' +
           'class="calendar-icon" type="button" id="calendaricon" name="calendaricon"></button>';
       html += '<br/>';
     }
         html += '<br/><button class="button nicebutton" onclick="cpac.tennis.savePaymentPlan(this.parentNode.parentNode.parentNode)">save</button>';
  
         daysDiv.innerHTML = html;
         modalWin.updateHeight();
  
   }
     catch(e){cpac.error(e);}}
  
     ,savePaymentPlan: function (newPlan) {try {
         var curPlan = $('rcPaymentPlan');
         curPlan.innerHTML = newPlan.innerHTML;
         var curInputs = curPlan.getElementsByTagName('input');
         var newInputs = newPlan.getElementsByTagName('input');
         for (var i=0; i < curInputs.length; i++) {
       curInputs[i].value = newInputs[i].value;
       curInputs[i].setAttribute('value', newInputs[i].value);
     }
         closeModalForm();
  
         if( $j('#payments-plan').is('div')) {
             var n = curInputs.length - 1;
             $j('#payments-plan').html( n + ' Payments Plan' );
         }
   }
     catch(e){cpac.error(e);}}
   
   ,updateLessonTypes: function() {
       try {
            var locationId = $j('#courtScheduleProperties input[name="locations"]').val();
            var currentType = $j('#courtScheduleProperties input[name="lesson_type"]').val();
            
            var href = cpac.tennis.baseUrl + cpac.tennis.defaultController + '/lesson-types';
            var postData = 'locations=' + locationId +
                    '&default=' + currentType;
            
            $j.caPost(href, postData, function(response) { 
            $j('#lesson-types-block').html(response); 
            }, 'html', false );
        
        } catch(e){
            cpac.error(e);
        } 
    },
    reserveResourcewaitlist: function () {
        try {
            var href = cpac.tennis.baseUrl + cpac.tennis.defaultController + "/resource-waitlist";
            var requestData = $("courtScheduleProperties").serialize();
            $j.caPost(href, requestData, function (response) {
                if (response.status == 1) {
                    $j(response.message).appendTo('body');
                    $j('#confirm-reservation-popup_waitlist').caDialog('close');
                    $j('#confirm-reservation-popup_waitlist').caDialog({
                        title:"Waitlist Confirmation",
                        resizable: true,
                        beforeClose: function () {
                            $(this).remove();
                        },
                        width: 650,
                        height: 400,
                        showCloseButton: true,
                        modal: true
                    });
                } else {
                    $j.caAlert(response.message);
                }
            }, 'json', true );
        } catch (e) {
            cpac.error(e);
        }
    },
    reserveResourcewaitlistSave: function () {
        try {
            var href = cpac.tennis.baseUrl + cpac.tennis.defaultController + "/resource-waitlist";
            var requestData = $("courtScheduleProperties").serialize();
            $j.caPost(href + "?is_confirmed=1", requestData, function (response) {
                if (response.status == 0) {
                    $j.caAlert(response.message);
                } else {
                    href += href.indexOf('?') > -1 ? '&date=' : '?&date=';
                    href += $('date').value;
                    href += '&locations=' + ( $('locations') ? $('locations').value : 0 );

                    this.updating = true;
                    showResources(null, href ,
                        'court-properties-container');
                }
                $j('#confirm-reservation-popup_waitlist').caDialog('close');
            }, 'json', true );
        } catch (e) {
            $j('#confirm-reservation-popup_waitlist').caDialog('close');
            cpac.error(e);
        }
    },
    removeResourceWaitlistUser: function (id) {
        try {
            var location = $j('#courtScheduleProperties input[name="locations"]').val();
            var date = $j('#courtScheduleProperties input[name="date"]').val();
            var href = cpac.tennis.baseUrl + cpac.tennis.defaultController + '/remove-resource-waitlist';
            $j.caConfirm('The host will no longer receive notifications for any matching openings. ' +
                'Are you sure you want to remove this entry from the waitlist?', '', 'Yes, Remove', 'Cancel',
                function () {
                    $j.caPost(
                        href,
                        {
                            'id': id,
                            'location': location,
                            'date': date
                        },
                        function (response) {
                            if (response.status == 1) {
                                $j('#resource-waitlist-users').html(response.content);
                            } else if (response.status == 0) {
                                $j.caAlert(response.message);
                            }
                        },
                        'json');
                });
        } catch (e) {
            cpac.error(e);
        }
    },
    addPlayersResourceWaitlist: function (componentId) {
        window.cpacTennisPlayerHidePrice = true;
        var addAnother = 'Add a participant';
        var prefix = 'rc';
        $(prefix + 'UserName').value = addAnother;
        $(prefix + 'UserName').observe('blur', function () {
            if (this.value == '') this.value = addAnother;
        });
        $(prefix + 'UserName').observe('focus', function () {
            if (this.value == addAnother) this.value = '';
        });
        $(prefix + 'UserName').observe('focus', function () {
            cpac.tennis.nameFieldOnFocus(
                prefix + 'UserName',
                prefix + 'UserId',
                prefix + 'UserIsGuest',
                null,
                1,
                null,
                null,
                1,
                function (obj) {
                    $(prefix + 'UserId').value = obj.id;
                    if ($(prefix + 'UserId').onchange) {
                        $(prefix + 'UserId').onchange()
                    }
                    cpac.tennis.addPlayerRC();
                }, 1, componentId);
        });
        var addPrimary = 'Add a Host';
        cpac.tennis.placeholderForOther = addAnother;
        cpac.tennis.placeholderForPrimary = addPrimary;
        cpac.tennis.reserveForMember = true;
        var addPlayer = cpac.tennis.playersAdded ? cpac.tennis.placeholderForOther : cpac.tennis.placeholderForPrimary
        $j('#host').caUserPicker({
            placeholder: addPlayer
        }).on('causerpickeritemadded', function (event, item) {
            $j('#rcUserId').val(item.id);
            $j('#rcUserName').val(item.label);
            $j('#rcUserIsGuest').val(item.isNotMember ? 1 : 0);

            cpac.tennis.addPlayerRC();
            var $container = $j(this);
            $container.caUserPicker('clearItem');
            var data = $container.caUserPicker('option', 'data');
            data.doNotShow.push(item.id);
            $container.caUserPicker('option', 'data');
            $container.caUserPicker('option', 'placeholder', cpac.tennis.placeholderForOther);

            $container.blur();
            var $cross = $j('#rcPlayer' + item.id).find('.fb-user-box-close').first();
            $cross.on('click', function () {
                var data = $container.caUserPicker('option', 'data');
                var doNotShow = [];
                for (var i in data.doNotShow) {
                    if (data.doNotShow.hasOwnProperty(i) && data.doNotShow[i] != item.id) {
                        doNotShow.push(data.doNotShow[i]);
                    }
                }
                data.doNotShow = doNotShow;
                $container.caUserPicker('option', 'data');
                $container.blur();
            });
        });
    }
  }

  cpac.tennis.fixedScrollHandler = function(){
    $('court-properties-container').setStyle({backgroundColor: '#fff', zIndex: 1});
    var f = new leFixedScroll(
        'court-properties-container'
        ,function(){if( $('court-properties-inner-container')) $('court-properties-inner-container').setStyle({borderTop: '0 none'});}
        ,function(){if( $('court-properties-inner-container')) $('court-properties-inner-container').setStyle({borderTop: '1px solid #c6e3ed'});}
    );
    Event.observe(window, 'scroll', function(){f.onScroll()});
}

    cpac.tennis.cancelTemplateForm = function (scheduleId, resourceId, groupEx) {
        try {
            const href = "event/cancel-template-form";
            $j.caPost(href,
                {
                    's_id': scheduleId,
                    'resource_id': resourceId,
                    'group_ex': groupEx
                },
                function (response) {
                response = JSON.parse(response);
                if (response.status == 1) {
                    const dialog = jQuery(response.content).appendTo('body');
                    dialog.caDialog({
                        title : 'Cancel Class',
                        staticForm: false,
                        caProUI: true,
                        autoOpen : true,
                        autoResize : true,
                        resizable : false,
                        width : 830,
                        showCloseButton: true,
                    });
                } else {
                    $j.caAlert(response.message);
                }
            }, 'html', true);
        } catch (e) {
            cpac.error(e);
        }
    }

    cpac.tennis.classCancelAction = function () {
        jQuery('.class-template-form').caDialog('close');
    };

    cpac.tennis.classCancelSubmitAction = function (data, url, sendMail) {
        try {
            jQuery('.class-template-form').caDialog('close');
            if (sendMail) {
                runCKEditor.editor.updateElement();
                const href = "event/event-cancel-mail-and-notification";
                $j.caPost(href, data.serialize(), function (response) {
                    if (response.status == 1) {
                        console.log('mail send');
                    }
                }, 'json', false);
            }
            showResources($('courtScheduleProperties'), url, 'courtsInfo');
        } catch (e) {
            cpac.error(e);
        }
    };
}
